import { Tabs } from '@dixa/lib-shared-habla';
import { useInteractions } from '@floating-ui/react';
import { Popover } from 'articleEditor/components/popover';
import { FloatingProps } from 'articleEditor/hooks/hoverUtils';
import cx from 'classnames';
import Portal from 'components/portal';
import { ComponentProps, CSSProperties, ReactNode } from 'react';

import s from './uploadMenu.module.scss';

type UploadMenuProps = {
  id?: string;
  floatingProps: FloatingProps;

  getFloatingProps:
    | ReturnType<typeof useInteractions>['getFloatingProps']
    | null;

  /** Render the tabs */
  tabsChildren?: ReactNode;

  /** Render tab content */
  children: ReactNode;
};

export function UploadMenu({
  id,
  floatingProps,
  getFloatingProps,
  tabsChildren,
  children,
}: UploadMenuProps): JSX.Element {
  const { isOpen, strategy, x, y } = floatingProps;
  const style: CSSProperties = {
    position: strategy,
    top: y ?? 0,
    left: x ?? 0,
    opacity: 1,
  };

  if (!isOpen) return <></>;

  return (
    <Portal>
      <Popover
        id={id}
        style={style}
        ref={floatingProps.refs.setFloating}
        {...getFloatingProps?.()}
      >
        {tabsChildren && (
          <div className={s.uploadFormHeader}>{tabsChildren}</div>
        )}
        <div>{children}</div>
      </Popover>
    </Portal>
  );
}

type UploadTabsProps = ComponentProps<typeof Tabs>;

export function UploadTabs({
  tabClassName,
  ...props
}: UploadTabsProps): JSX.Element {
  return <Tabs tabClassName={cx(s.tabs, tabClassName)} {...props}></Tabs>;
}
